export default function cookieFactory(
    $cookies,
    cookieModel,
    localStorageService
) {
    var obj = this;

    obj.filterGrantedCookieCategories = function (cookieCategories) {
        let grantedCookieCategories = [];

        angular.forEach(cookieCategories, function (category) {
            if (category.checked) {
                grantedCookieCategories.push(category.name);
            }
        });

        return grantedCookieCategories;
    };

    obj.initUserCategories = function (currentCookieAllowance) {
        let categories = [];

        angular.forEach(angular.copy(cookieModel.cookies), function (category) {
            // Remove cookies from each category (not needed here)
            delete category.cookies;

            // Update category selection from User Cookie

            if (currentCookieAllowance) {
                if (currentCookieAllowance.indexOf(category.name) != -1) {
                    category.checked = true;
                } else {
                    category.checked = false;
                }
            }

            categories.push(category);
        });

        return categories;
    };

    obj.removeDisallowCookies = function () {
        let allowedCookieCategories = localStorageService.cookie.get(
            "cookieCompliance"
        );

        let reloadRequired = false;
        angular.forEach(cookieModel.cookies, function (category) {
            if (allowedCookieCategories.indexOf(category.name) === -1) {
                angular.forEach(category.cookies, function (cookie) {
                    if (cookie.type == "http") {
                        reloadRequired = true;
                    }

                    if (cookie.storageType == "cookie") {
                        $cookies.remove(cookie.name);

                        // NOTE !!! cookies with "http" cannot only be removed from issuer!
                        // AKA: it not possible to remove Siteimprove cookies without reloading the page.
                    }

                    if (cookie.storageType == "storage") {
                        localStorageService.remove(cookie.name);
                    }
                });
            }
        });

        if (reloadRequired) {
            window.location.reload();
        }
    };

    obj.setAllowedCookies = function () {
        /*  
            $cookies.put("testCookie", "testCookie", 10);

              
            localStorageService.set("testStorage", {
            test: "testStorageCookie",
        }); 
        */
    };

    return obj;
}
